import { useMemo } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { App as AntApp, Col, ConfigProvider, Empty, Layout, Row, Typography, theme } from 'antd'

import '@/assets/App.css'
import AppLogo from '@/assets/highlights_travel_300_300_250613.png'
import { useThemeContext } from '@/stores/ThemeContext'

const { Header, Footer, Content } = Layout
const { Title } = Typography

const HEADER_STYLE = { position: 'sticky', top: 0, zIndex: 1, width: '100%', background: 'white' }
const HEADER_COL_STYLE = { color: 'white', marginBottom: '0', display: 'flex', justifyContent: 'center' }
const CONTENT_BASE = { padding: 24, margin: 0, minHeight: 280 }

function Standlone() {
  const { colorPrimary, borderRadius } = useThemeContext()

  const {
    token: { colorBgContainer },
  } = theme.useToken()

  const contentStyle = useMemo(
    () => ({ ...CONTENT_BASE, background: colorBgContainer }),
    [colorBgContainer],
  )

  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary, borderRadius },
        algorithm: theme.defaultAlgorithm,
      }}
      renderEmpty={() => <Empty description={false} />}
    >
      <AntApp>
        <Layout>
          <Header className="header" style={HEADER_STYLE}>
            <Row gutter={{ md: 24 }} align="middle">
              <Col flex="auto" style={HEADER_COL_STYLE}>
                <NavLink to="/">
                  <img src={AppLogo} className="logo" alt="App logo" />
                </NavLink>
                <Title level={3}>销售平台</Title>
              </Col>
            </Row>
          </Header>
          <Layout>
            <Content style={contentStyle}>
              <Outlet />
            </Content>
          </Layout>
          <Footer>桂林海纳国际旅行社有限公司</Footer>
        </Layout>
      </AntApp>
    </ConfigProvider>
  )
}

export default Standlone
